import { ApiClients } from '@roolz/api/clients'
import {
  changePasswordRequest,
  changePasswordResponse,
  checkIfEmailBusyRequest,
  checkIfEmailBusyResponse,
  DeleteAuthPhoneRequest,
  deleteOwnEmailRequest,
  deleteOwnEmailResponse,
  deleteOwnPasswordRequest,
  deleteOwnPasswordResponse,
  deleteOwnProfileRequest,
  Device,
  LoadProfilesByIdsRequest,
  PatchProfileRequest,
  Profile,
  TiedSocialNetworks,
  untieSocialNetworkRequest,
  updateOwnEmailRequest,
  updateOwnEmailResponse,
  updateOwnPhoneRequest,
  ValidateCurrentPasswordRequest
} from '@roolz/types/api/profiles'
import { AxiosInstance } from 'axios'
import { cancelAccountDeletionRequest, createInvitationRequest } from 'static/src/types/api'

export class ProfilesApi {
  identity: AxiosInstance
  identity2: AxiosInstance

  constructor(clients: ApiClients) {
    this.identity = clients.identity
    this.identity2 = clients.identity2
  }

  getById(id: Profile['id']) {
    return this.identity2.get<Profile>('/v1/private/profile/' + id)
  }

  createInvitation(user_id, body: createInvitationRequest) {
    return this.identity.post(`/v1/profile/${user_id}/invitation/create`, body)
  }

  cancelDeletionByToken(body: cancelAccountDeletionRequest) {
    return this.identity2.post('/v1/public/profile/cancel_deletion_by_token', body)
  }

  getByIds(params: LoadProfilesByIdsRequest) {
    // // @ts-ignore
    // params.profile_ids = params.profile_ids.join(',')

    return this.identity.get<Profile[]>('/v1/profile/list/by_ids', { params })
  }

  retrieveMe() {
    return this.identity2.get<Profile>('/v1/private/me/profile')
  }

  retrieveMyDevice() {
    return this.identity2.get<Device>('/v1/private/me/device')
  }

  getMySocialNetworks() {
    return this.identity2.get<TiedSocialNetworks>('/v1/private/me/profile/socials')
  }

  untieSocialNetwork(params: untieSocialNetworkRequest) {
    return this.identity2.delete<TiedSocialNetworks>('/v1/private/me/profile/delete_social', { params })
  }

  checkIfEmailBusy(params: checkIfEmailBusyRequest) {
    return this.identity2.get<checkIfEmailBusyResponse>('/v1/public/profile/check_email', { params })
  }

  updateMyProfile(body: Partial<PatchProfileRequest>) {
    return this.identity2.patch<Profile>('/v1/private/me/profile', body)
  }

  deleteOwnProfile(body: deleteOwnProfileRequest) {
    return this.identity2.post<Profile>('/v1/private/me/profile/delete', body)
  }

  changePassword(body: changePasswordRequest) {
    return this.identity2.post<changePasswordResponse>('/v1/private/me/profile/update_auth_password', body)
  }

  deleteOwnEmail(body?: deleteOwnEmailRequest) {
    return this.identity2.post<deleteOwnEmailResponse>('/v1/private/me/profile/delete_auth_email', body)
  }

  validateCurrentPassword(body?: ValidateCurrentPasswordRequest) {
    return this.identity2.post('/v1/private/me/profile/validate_password', body)
  }

  updateOwnEmail(body: updateOwnEmailRequest) {
    return this.identity2.post<updateOwnEmailResponse>('/v1/private/me/profile/update_auth_email', body)
  }

  updateOwnPhone(body: updateOwnPhoneRequest) {
    return this.identity2.post('/v1/private/me/profile/update_auth_phone', body)
  }

  deleteOwnPhone(body?: DeleteAuthPhoneRequest) {
    return this.identity2.post('/v1/private/me/profile/delete_auth_phone', body)
  }
  deleteOwnPassword(body: deleteOwnPasswordRequest) {
    return this.identity2.post<deleteOwnPasswordResponse>('/v1/private/me/profile/delete_auth_password', body)
  }
}
